import selectedCategoryReducer from "./SelectedCategories";

export const reducer = selectedCategoryReducer
export * from "./SelectedCategories";